import { Link } from 'react-router-dom';
import { LegalLayout } from '../../components/LegalLayout';

export function MentionsLegalesPage() {
  return (
    <LegalLayout
      title="Mentions légales"
      lead="Conformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN)."
    >
      <h2>Éditeur du site et du jeu</h2>
      <p>
        <strong>Florian Augeard</strong><br />
        Entrepreneur individuel — nom commercial <strong>PrograGames</strong><br />
        Siège : 49000 Angers, France
      </p>
      <p>
        SIREN : 106 684 780 · RCS Angers<br />
        TVA non applicable, article 293 B du CGI
      </p>
      <p>
        <strong>Dezoom</strong> est édité et commercialisé par PrograGames.<br />
        Contact :{' '}
        <a href="https://progragames.com/contact.html" target="_blank" rel="noopener noreferrer">
          formulaire PrograGames
        </a>
      </p>

      <h2>Directeur de la publication</h2>
      <p>Florian Augeard</p>

      <h2>Hébergement</h2>
      <p>
        <strong>Scaleway SAS</strong><br />
        8 rue de la Ville l'Évêque, 75008 Paris, France<br />
        <a href="https://www.scaleway.com/" target="_blank" rel="noopener noreferrer">www.scaleway.com</a>
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        L'ensemble du site Dezoom (textes, interface, logo) est protégé.
        Les photographies utilisées dans les énigmes sont créditées sur la page{' '}
        <Link to="/credits">Crédits photos</Link> (sources Pexels, Unsplash).
      </p>

      <h2>Documents contractuels</h2>
      <ul>
        <li><Link to="/cgu">Conditions générales d'utilisation (CGU)</Link></li>
        <li><Link to="/cgv">Conditions générales de vente (CGV)</Link></li>
        <li><Link to="/confidentialite">Politique de confidentialité</Link></li>
      </ul>
    </LegalLayout>
  );
}
